import React from "react";
import { t } from "@bookingcom/lingojs-core";
import { useI18n, I18nChildContext } from "@bookingcom/lingojs-react";
import { Text } from "@bookingcom/bui-react";

import LoadingScreen from "../LoadingScreen";

import CheckoutIllustration from "../../../../assets/loadingScreens/checkout.svg";
import Frame from "components/elements/Frame";

const CheckoutLoadingScreen: React.FunctionComponent = () => {
  const i18n = useI18n() as I18nChildContext;

  return (
    <LoadingScreen illustration={CheckoutIllustration} title={i18n.trans(t("flights_loading_message_payment"))}>
      <Frame mt={8} mr={3} mb={8} ml={3} alignItems="center">
        <Text variant="headline_2">{i18n.trans(t("flights_loading_message_payment"))}</Text>
      </Frame>
    </LoadingScreen>
  );
};

export default CheckoutLoadingScreen;
